import {Platform, Text, TouchableOpacity, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {useNavigation, useNavigationState} from '@react-navigation/native';
import {generateTabTitleForBreadCrumbs} from 'helpers/generateTabTitleForBreadCrumbs';
import styleSheet from './styles';

export interface BreadCrumbsWebProps {
  dynamicTitle?: string;
  onPress?(): void;
}

const BreadCrumbsWeb = (props: BreadCrumbsWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const navigation = useNavigation();
  const breadCrumbs = useNavigationState(item => item.routes);

  const onPress = (value: string) => {
    if (props.onPress) {
      props.onPress();
    }

    navigation.navigate(value as never);
  };

  return (
    <>
      {Platform.OS === 'web' && (
        <View style={styles.containerStyle}>
          <>
            {breadCrumbs.map((item, index, arr) => {
              const activeTab = index + 1 === arr.length;

              return (
                <TouchableOpacity
                  key={item.key}
                  onPress={() => onPress(item.name)}
                  style={styles.tabButtonStyle}
                  disabled={activeTab}>
                  <Text
                    style={
                      activeTab
                        ? styles.lastTabButtonLabelStyle
                        : styles.tabButtonLabelStyle
                    }>
                    {generateTabTitleForBreadCrumbs(
                      item.name,
                      props.dynamicTitle,
                    )}
                  </Text>

                  {!activeTab && (
                    <Text
                      style={[
                        styles.tabButtonLabelStyle,
                        styles.marginHorizontal,
                      ]}>
                      /
                    </Text>
                  )}
                </TouchableOpacity>
              );
            })}
          </>
        </View>
      )}
    </>
  );
};

export default BreadCrumbsWeb;
